import axios from 'axios'
import { store } from '@/vue/store'

declare global {
  interface Window {
    BASE_URI: string
  }
}

axios.defaults.baseURL = `${window.BASE_URI}api`
axios.defaults.withCredentials = true
axios.interceptors.response.use((response) => response, (error) => {
  if (error) {
    if (error.response && error.response.status === 401) {
      store.commit('setStatusAnon')
    }
    throw error
  }
})
